import ClientModule from "@gqlapp/module-client-react";
import Route from "@lib/Route";
import View from "@modules/video/components/view";
import {defaultRoute, getProps} from "@modules/video/helpers/config";

export default new ClientModule({
	route:{ Video: <Route {...getProps(defaultRoute, View, { classNameOnPage: 'video' })} /> }
});
